class PayloadStrategy {
	payloadToCreate() {
		throw new Error("This method must be overwritten");
	}

	payloadToUpdate() {
		throw new Error("This method must be overwritten");
	}

	payloadToFetch() {
		throw new Error("This method must be overwritten");
	}

	filtrableProperties() {
		throw new Error("This method must be overwritten");
	}
}

export default PayloadStrategy;
